export const CHANGE_THEME = "change_theme";
export const CHANGE_LANG = "change_lang";
export const INITIALIZE = "init";
export const LOGGED_IN = "isLoggedIn";
export const USER_PROFILE = "user_profile";
export const USER_BILL_DETAILS = "user_bill_details";
export const GROUPS_CATEGORIES_DATA = "groups_categories_data";
export const CLIENT_CONFIG_DETAILS = "client_config_details";
export const SELECTED_CATEGORY = "selected_category";
export const SELECTED_BILLER = "selected_biller";
export const NUMBER_FOR_RECHARGE = "number_for_recharge";
export const NOTIFICATION_DATA = "notifications_data";
